var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasMoreResults)?_c('TotemButton',{attrs:{"icon":"add","color":"primary","label":_vm.$t('General.load_more')},on:{"click":_vm.loadMore}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }